
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.18 14.442L2.525 10.43c-.736-.443-.607-1.548.212-1.809l15.97-5.093a.97.97 0 011.073.312.97.97 0 01.312 1.073L15 20.883c-.261.819-1.365.949-1.809.213l-4.012-6.654zm6.215-7.758L5.447 9.857l4.227 2.548 5.721-5.72zm1.542 1.542l-5.72 5.721 2.548 4.227 3.172-9.948z"}})])
          )
        }
      }
    